/**
 * Normalize one whitelist line to a bare hostname (lowercase).
 * Accepts full URLs (https://host/path), bare hostnames, and strips ports.
 */
export function normalizeDomainWhitelistEntry(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;
  try {
    if (/^https?:\/\//i.test(s)) {
      return new URL(s).hostname.toLowerCase();
    }
    const first = s.split('/')[0];
    const host = first.split(':')[0].trim().toLowerCase();
    if (!host || /\s/.test(host)) return null;
    return host;
  } catch {
    return null;
  }
}

/** Dedupe; invalid lines are skipped. */
export function normalizeDomainWhitelist(lines: string[]): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const line of lines) {
    const h = normalizeDomainWhitelistEntry(line);
    if (h && !seen.has(h)) {
      seen.add(h);
      out.push(h);
    }
  }
  return out;
}
